<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-header">
        <h3>CHI TIẾT LỜI NHẮN</h3>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm">
          <b-row>
            <b-col md="12">
              <b-row>
                <b-col sm="3">
                  <el-form-item label="Họ tên">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.ho_ten"
                      disabled
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col sm="3">
                  <el-form-item label="Điện thoại">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.dien_thoai"
                      disabled
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col sm="3">
                  <el-form-item label="Email">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.email"
                      disabled
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col sm="3">
                  <el-form-item label="Ngày gửi">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.thoi_diem_tao"
                      disabled
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <el-collapse v-model="activeNames">
                    <el-collapse-item
                      accordion="true"
                      title="Nội dung"
                      name="1"
                    >
                      <el-input
                        type="textarea"
                        v-model="mData.dataForm.noi_dung"
                        rows="22"
                      ></el-input>
                    </el-collapse-item>
                  </el-collapse>
                </b-col>
                <b-col md="6">
                  <b-row v-if="anh_url">
                    <b-col md="12">
                      <div class="image-box">
                        <img
                          v-if="anh_url"
                          width="100%"
                          :src="anh_url"
                          alt="ảnh lời nhắn"
                          style="height: 506px; object-fit: contain"
                        />
                        <div v-else class="image-none">
                          <i class="fas fa-eye-slash"></i>
                          <p>Chưa có thông tin ảnh</p>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="mt-3" md="4">
                  <el-collapse @change="handleNoiDungPhanHoi()">
                    <el-collapse-item>
                      <template slot="title">
                        <i class="fas fa-plus"></i> PHẢN HỒI MỚI
                      </template>
                      <div class="phan-hoi-radio">
                        <el-radio
                          v-model="trangThaiEmail"
                          label="gui"
                          style="margin-right: 15px"
                          >Gửi email</el-radio
                        >
                        <el-radio v-model="trangThaiEmail" label="luu"
                          >Nhận email</el-radio
                        >
                      </div>
                      <el-input
                        type="textarea"
                        :rows="11"
                        placeholder="Nhập nội dung phản hồi"
                        v-model="noiDungPhanHoi"
                      >
                      </el-input>
                      <div class="text-center mt-2 group-btn-email">
                        <el-button
                          type="primary"
                          :disabled="noiDungPhanHoi.trim() == ''"
                          v-show="trangThaiEmail == 'gui'"
                          @click="fn_guiPhanHoi('viettoc')"
                          icon="el-icon-upload2"
                          >Gửi</el-button
                        >
                        <el-button
                          type="primary"
                          :disabled="noiDungPhanHoi.trim() == ''"
                          v-show="trangThaiEmail == 'luu'"
                          @click="fn_guiPhanHoi('khach')"
                          icon="el-icon-download"
                          >Lưu</el-button
                        >
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </b-col>
                <b-col md="8">
                  <el-collapse class="mt-3">
                    <el-collapse-item>
                      <template slot="title">
                        <i class="fas fa-history"></i> LỊCH SỬ PHẢN HỒI
                      </template>

                      <div
                        v-if="danhSachPhanHoi.length == 0"
                        class="text-center"
                      >
                        Chưa có nội dung phản hồi
                      </div>
                      <div class="lich_su_container" v-else>
                        <div
                          v-for="item in danhSachPhanHoi"
                          :key="item.id"
                          class="lich-su"
                        >
                          <div class="collapse-content__time">
                            <div v-if="item.nguoi_gui == 'viettoc'">
                              <i class="fas fa-user-headset"></i>
                            </div>
                            <div v-else>
                              <i class="fas fa-user"></i>
                            </div>
                            <div class="lich-su__time">
                              {{ item.thoi_diem_tao }}
                            </div>
                          </div>
                          <div class="lich-su__content">
                            <p>{{ item.noi_dung }}</p>
                          </div>
                        </div>
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <div class="text-center mt-3">
            <el-button type="primary" @click="fn_back()" v-ladda
              >quay lại</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import mushroom from "viettoc-api";
import MethodService from "../../../service/MethodService";
import LanguageService from "../../../service/LanguageService";
import DataForm from "../../../dataForm/dataFormLoiNhan";
import { Circle4 } from "vue-loading-spinner";
export default {
  data() {
    return {
      activeNames: ["1"],
      aLang: LanguageService.lang,
      loading: true,
      mData: {
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(DataForm.tableRules),
      },
      anh_url: "",
      trangThaiEmail: "",
      noiDungPhanHoi: "",
      danhSachPhanHoi: [],
    };
  },

  components: {
    Circle4,
  },

  methods: {
    async fn_listForm() {
      try {
        const response = await mushroom.ldp_loi_nhan.findByIdAsync({
          id: this.$router.currentRoute.params.id,
          fields:
            "id,ho_ten,dien_thoai,email,noi_dung,loai_loi_nhan,file_dinh_kem,thoi_diem_tao",
        });
        this.mData.dataForm = response.result;
        this.mData.dataForm.thoi_diem_tao = MethodService.formatDate(
          this.mData.dataForm.thoi_diem_tao,
          "datetime"
        );
        this.mData.dataForm.dien_thoai = MethodService.formatPhone(
          this.mData.dataForm.dien_thoai
        );
        if (response.result.file_dinh_kem) {
          this.anh_url = mushroom.$file.linkBuilder.thumb
            .id(response.result.file_dinh_kem)
            .build();
        }

        this.loading = false;
        console.log("Lời nhắn chi tiết:", response);
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    // nội dung phản hồi
    handleNoiDungPhanHoi(val) {
      this.noiDungPhanHoi = "";
      this.trangThaiEmail = "";
    },
    handleLichSuPhanHoi(val) {
      this.lichSuPhanHoi = "";
    },
    async fn_guiPhanHoi(nguoiGui) {
      const loi_nhan_phan_hoi_object = {
        loi_nhan_id: this.$router.currentRoute.params.id,
        noi_dung: this.noiDungPhanHoi.trim(),
        nguoi_gui: nguoiGui,
      };
      try {
        const newId = await mushroom.ldp_loi_nhan_phan_hoi.createAsync(
          loi_nhan_phan_hoi_object
        );
        if (newId.result) {
          console.log("nội dung phản hồi:", loi_nhan_phan_hoi_object);
          // window.toastr.success("Gửi phản hồi lời nhắn thành công");
          this.noiDungPhanHoi = "";
          await this.fn_getNoiDungPhanHoi();
        }
      } catch (error) {
        console.error("Có lỗi: %o", error);
        if (error.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (error.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
        } else window.toastr.error("Đã có lỗi xảy ra");
      }
    },
    async fn_getNoiDungPhanHoi() {
      try {
        const response = await mushroom.ldp_loi_nhan_phan_hoi.listAsync({
          fields:
            "id,noi_dung,loi_nhan_id,nguoi_gui,thoi_diem_tao,nguoi_tao_id",
          filters: ["loi_nhan_id=" + this.$router.currentRoute.params.id],
          sort: "-thoi_diem_tao",
        });
        console.log("lời nhắn phản hồi", response.result);
        let noiDung = await this.fn_changeDataPhanHoi(response.result);
        this.danhSachPhanHoi = [];
        noiDung.forEach((item) => {
          this.danhSachPhanHoi.push({
            nguoi_gui: item.nguoi_gui,
            noi_dung: item.noi_dung.trim(),
            thoi_diem_tao: item.thoi_diem_tao,
          });
        });
        console.log("noi dung", this.danhSachPhanHoi);
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    fn_changeDataPhanHoi(data) {
      data.forEach((element) => {
        element.thoi_diem_tao = MethodService.formatDate(
          element.thoi_diem_tao,
          "datetime"
        );
      });
      return data;
    },
    // quay lại danh sách lời nhắn
    fn_back() {
      //this.$router.go(-1);
      this.$router
        .replace({
          name: "DanhSachLoiNhan",
        })
        .catch((err) => {});
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
  },
  async created() {
    await this.fn_listForm();
    await this.fn_getNoiDungPhanHoi();
  },
};
</script>

<style scoped lang="scss">
.image-box {
  border: 1px dashed #409eff;
  border-radius: 5px;
  overflow: hidden;
  transition: 0.3s;
  height: 514px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hide {
  display: none;
}
.image-none {
  color: #a7a7a7;
  text-align: center;
  i {
    font-size: 50px;
  }
  p {
    margin-top: 15px;
  }
}
.lich-su {
  margin-bottom: 8px;
  &__time {
    min-width: 123px;
    width: fit-content;
    border-radius: 12px;
    padding: 0 7px;
    line-height: 18px;
    background-color: #f56c6ce6;
    color: #e7e7e7;
    font-weight: 600;
    font-size: 12px;
    margin-bottom: 5px;
  }
  &__content {
    padding-left: 10px;
    p {
      white-space: pre-line;
    }
  }
  &__text {
    text-align: center;
    font-weight: 600;
    font-size: 14px;
  }
}
.collapse-content__time {
  display: flex;
  .fa-user {
    color: rgb(48, 146, 238);
    margin-right: 5px;
  }
  .fa-user-headset {
    color: rgb(1, 151, 63);
    margin-right: 5px;
  }
}
.group-btn-email button {
  margin-left: 0;
}
.lich_su_container {
  margin-top: 4px;
  max-height: 303px;
  overflow: auto;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
  padding: 10px;
}
</style>
